<!--
  Loading.vue
    Loading Component
-->

<!-- -------------------------------------------------------------------------------- -->
<template>
  <loading
    :active.sync="isLoading"
    :can-cancel="true"
    :on-cancel="onCancelLoading()"
    :is-full-page="fullPage"
    :z-index="100"
    :width="50"
    :height="50"
    class="hm-loading"
    color="#7f7f7f"
  >
  </loading>
</template>

<!-- -------------------------------------------------------------------------------- -->
<script>
import Loading from 'vue-loading-overlay'

export default {
  name: 'Loading',
  components: {
    'loading': Loading
  },
  data: () => ({
    isLoading: false,
    fullPage: true
  }),
  mounted: function () {
    this.$log.debug('# Loading')
    this.$on('show', this.showLoading)
    this.$on('hide', this.hideLoading)
  },
  destroyed: function () {
    this.$log.debug('# Loading')
  },
  methods: {
    // -------------------------------------------------------------------------
    showLoading: function () {
      this.isLoading = true
    },
    hideLoading: function () {
      setTimeout(() => {
        this.isLoading = false
      }, 1500)
    },
    onCancelLoading: function () {
    },
  },
}
</script>

<!-- -------------------------------------------------------------------------------- -->
<style scoped>
.hm-loading {
  position: absolute;
  height: 50px;
  width: 50px;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/Loading.vue